import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import {
  appBackgroundColor,
  appFontColor,
  regularFont,
  screenSize,
} from '@app/styles';

type Props = {
  bodyMargin?: string;
  backgroundColor?: string;
};

const GlobalStyles = createGlobalStyle`
  ${normalize}

  * {
    box-sizing: border-box;
  }

  html, body, #root {
    height: 100%;
  }

  body {
    font-family: 'Noto Sans';
    font-size: 15px;
    ${regularFont}
    background-color: ${appBackgroundColor};
    color: ${appFontColor};

    @media (${screenSize.tablet}) {
      font-size: 14px;
    }
  }

  #root {
    display: flex;
    flex-direction: column;
  }
  *::-webkit-scrollbar {
    width: 3px;
}


*::-webkit-scrollbar-track {
    background: #fafafa; 
    width: 3px;
}
 

*::-webkit-scrollbar-thumb {
    background:#c1c1c1 ; 
    border-radius: 3px;
}

`;

export default GlobalStyles;
